export const StubTrackingInfo = {
  company: '',
  date: '',
  invoice: '',
  number: '',
  statushistory: {
    status: [{ eventtime: '', office: '', title: '' }],
  },
  town: '',
};

export const NoFoundServerText = 'Не удалось найти.';
